import { Component, Fragment, h, Prop } from '@stencil/core';

@Component({
  tag: 'vs-alp-success',
  shadow: false,
})
export class VsAlpSuccess {

  /* START: ALP workflow related props */
  /**
   * @shortDescription alpSuccessScreenReaderText
   * @controlName alpSuccessScreenReaderText */
  @Prop() alpSuccessScreenReaderText: string;

  /**
   * @shortDescription alpConfirmationHeading
   * @controlName alpConfirmationHeading */
  @Prop() alpConfirmationHeading: string;

  /**
   * @shortDescription alpConfirmationDescription
   * @controlName alpConfirmationDescription */
  @Prop() alpConfirmationDescription: string;

  // START GENAI@GHCOPILOT
 /**
   * @shortDescription alpConfirmationMiddle
   * @controlName alpConfirmationMiddle */
  @Prop() alpConfirmationMiddle: string;

  /**
   * @shortDescription alpConfirmationEnd
   * @controlName alpConfirmationEnd */
  @Prop() alpConfirmationEnd: string;
  // END GENAI@GHCOPILOT

  /**
   * @shortDescription alpConfirmationLinkText
   * @controlName alpConfirmationLinkText */
  @Prop() alpConfirmationLinkText: string;

  /**
   * @shortDescription alpSuccessBinText
   * @controlName alpSuccessBinText */
  @Prop() alpSuccessBinText: string;

  /**
   * @shortDescription successALPData
   * @controlName successALPData */
  @Prop() successALPData: any;


  postALPUrl = () => {
    let data = {
      cardnum: this.successALPData.binUrl,
      cardtype: this.successALPData.CardTypeCd
    };

    let form = document.createElement('form');
    form.method = 'post';
    form.action = this.successALPData.merchantUrl;
    form.style.display = 'none';

    for (let key in data) {
      let input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = data[key];
      form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();
  }

  render() {
    return (
      <Fragment>
        <p class="vs-sr-only" role="alert" aria-live="assertive">
          {this.alpSuccessScreenReaderText}
        </p>
        <div class='vs-mx-auto vs-col-lg-9 vs-col-12'>
          <h1 class="vs-h2 vs-mt-5 vs-align-center">{this.alpConfirmationHeading}</h1>
          <p class="vs-text vs-align-center" innerHTML={this.alpConfirmationDescription} />
          <div class="vs-col-md-5 vs-mx-auto">
            <button class="vs-btn vs-btn-primary vs-btn-block"
                    onClick={this.postALPUrl}>{this.alpConfirmationLinkText}
            </button>
          </div>
          {this.alpConfirmationMiddle && <p class="vs-align-center" innerHTML={this.alpConfirmationMiddle} />}
          <hr class="vs-my-5 vs-line-break" />
          <div class='vs-container'>
            <div class='vs-col-md-5 vs-mx-auto'>
              <div class='vs-form-group vs-mb-1'>
                <p class='vs-text vs-mb-1' id='confirm-text' innerHTML={this.alpSuccessBinText}></p>
                <input class='form-control' type='text' value={this.successALPData?.bin}
                       disabled aria-labelledby='confirm-text' aria-label='bin' />
              </div>
            </div>
            {this.alpConfirmationEnd && <p class='red_note vs-my-5 vs-col-md-7 vs-mx-auto' innerHTML={this.alpConfirmationEnd} />}
          </div>
        </div>
      </Fragment>
    );
  }
}

